import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Control } from "./Control";
import { clamp, vector2dDistance } from "../../../utils/math";
export var EventHandler = /*#__PURE__*/function (_Control) {
  _inherits(EventHandler, _Control);
  var _super = _createSuper(EventHandler);
  function EventHandler(props) {
    var _this;
    _classCallCheck(this, EventHandler);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "adjustScrollToEdges", function () {
      var x = clamp(_this.scrollWidth - _this.state.gutterHorizontal, _this.state.gutterHorizontal)(_this.container.scrollLeft);
      var y = clamp(_this.scrollHeight - _this.state.gutterVertical, _this.state.gutterVertical)(_this.container.scrollTop);
      if (x !== _this.container.scrollLeft || y !== _this.container.scrollTop) {
        _this.transition(x, y, 250);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "buildMouseMoveHandler", function (initPos) {
      var initialX = initPos.x || 0;
      var initialY = initPos.y || 0;
      var x = initialX;
      var y = initialY;
      return function (event) {
        event.preventDefault();
        if (!_this.state.controlling) {
          var distance = vector2dDistance(initialX - event.clientX, initialY - event.clientY);
          if (distance > 5) {
            _this.setState({
              controlling: true
            });
          }
        }
        var movement = {
          x: x - event.clientX,
          y: y - event.clientY
        };
        x = event.clientX;
        y = event.clientY;
        _this.keyframeMove(movement.x, movement.y);
      };
    });
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EventHandler, [{
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var _this2 = this;
      event.persist();
      var keyCode = event.nativeEvent.keyCode || event.nativeEvent.which;
      if (keyCode === 1 && this.state.isScrollable) {
        var initialPosition = {
          x: event.nativeEvent.clientX,
          y: event.nativeEvent.clientY
        };
        var handleMouseMove = this.buildMouseMoveHandler(initialPosition);
        var handleMouseUp = function handleMouseUp() {
          window.removeEventListener('mousemove', handleMouseMove);
          window.removeEventListener('mouseup', handleMouseUp);
          _this2.setState({
            controlling: false
          });
          _this2.adjustScrollToEdges();
        };
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
      }
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart() {}
  }]);
  return EventHandler;
}(Control);